import { Cookies } from '@theme/storage.compiled';

//?gclid=123&utm_campaign=spring_sale&utm_source=google&utm_medium=cpc&utm_term=best_sellers&utm_content=ad1&fbclid=456
const UTM_PARAMS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'gclid',
  'fbclid',
];

const getCookieName = (param) => (param === 'gclid' ? 'saved_gclid' : param);

function storeUTMParams() {
  const urlParams = new URLSearchParams(window.location.search);

  for (const param of UTM_PARAMS) {
    const value = urlParams.get(param);
    if (value) {
      Cookies.createCookie(getCookieName(param), value, 30);
    }
  }
}

function populateUTMFields() {
  const inputs = document.querySelectorAll('input[data-utm]');
  for (const input of inputs) {
    const key = input.getAttribute('data-utm');
    if (!key) continue;

    const cookieValue = Cookies.readCookie(getCookieName(key));
    if (cookieValue) {
      input.value = cookieValue;
    }
  }
}

function initUtmParmSaveAndPopulate() {
  storeUTMParams();
  populateUTMFields();
}

document.addEventListener('DOMContentLoaded', initUtmParmSaveAndPopulate);
